module.exports = function getResource(label, vars = []) {
    let resources = {
        chooseLocation: 'Choisir un lieu'
    };
    return resources[label];
};
